// Shared enums/helpers describing the shape of analytics events.
// These are plain data types (not tied to any specific analytics provider)
// used to build payloads for Snowplow and other tracking calls.

export enum App {
  web = 'web',
  ios = 'ios',
  android = 'android',
}

export enum CommunicateCategory {
  intro = 'intro',
  game = 'game',
  mission = 'mission',
  chat = 'chat',
  all = 'all',
}

export const appFromString = (str: string): App => {
  switch (str) {
    case 'web':
      return App.web;
    case 'ios':
      return App.ios;
    case 'android':
      return App.android;
    default: {
      console.error('Invalid App value logged: ' + str);
      return App.web;
    }
  }
};

export const communicateCategoryFromString = (str: string): CommunicateCategory => {
  switch (str) {
    case 'intro':
      return CommunicateCategory.intro;
    case 'game':
      return CommunicateCategory.game;
    case 'mission':
      return CommunicateCategory.mission;
    case 'chat':
      return CommunicateCategory.chat;
    case 'all':
      return CommunicateCategory.all;
    default: {
      console.error('Invalid CommunicateCategory value logged: ' + str);
      return CommunicateCategory.intro;
    }
  }
};

export enum Status {
  locked = 'locked',
  some_words_learned = 'some_words_learned',
  most_words_learned = 'most_words_learned',
}

export enum SubtitleLanguage {
  source = 'source',
  target = 'target',
  none = 'none',
}

export enum StartSource {
  from_tab = 'from_tab',
  from_next = 'from_next',
  replay = 'replay',
}

export enum LearningSessionType {
  unknown_session_type = 'unknown_session_type',
  learn = 'learn',
  review = 'review',
  speed_review = 'speed_review',
  difficult_words = 'difficult_words',
  audio = 'audio',
  video = 'video',
  speaking = 'speaking',
  practice = 'practice',
  grammar_learn = 'grammar_learn',
  grammar_review = 'grammar_review',
  grammar_practice = 'grammar_practice',
  preview = 'preview',
  communicate_responses = 'communicate_responses',
}

export enum LanguageDirection {
  unknown_language_direction = 'unknown_language_direction',
  source = 'source',
  target = 'target',
}

export enum ResponseType {
  unknown_response_type = 'unknown_response_type',
  tapping = 'tapping',
  record_compare = 'record_compare',
  multiple_choice = 'multiple_choice',
  typing = 'typing',
  tracing = 'tracing',
  audio_multiple_choice = 'audio_multiple_choice',
  video_context = 'video_context',
  audio_segmentation = 'audio_segmentation',
  comprehension = 'comprehension',
  communicate_responses = 'communicate_responses',
}
